export default {
      id: "assistants-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#assistants-usage",
      toString: function () {
        return this.url;
      }
    }